{
  "title": "User Panel",
  "sections": {
    "2fa": {
      "title": "2FA (Two Factor Authentication)",
      "notenable": "You have not enabled 2FA yet. Use this QR code in your authenticator app to enable it.",
      "enable": "Congratulations! You already have 2FA enabled. Your account is more secure.",
      "link": "Or use this link:",
      "advice": "2FA is recommended to keep your account secure.",
      "validationcode": "Validation Code",
      "placeholder": "Enter the code to validate your 2FA",
      "2faAdvice": "The 2FA authentication is not enabled yet. Click to check it out.",
      "2farequired": "IMPORTANT: In 1st October, 2FA will be required for all Izzi Wallet users. Please, enable it as soon as possible. Read more about 2FA in this",
      "ibmarticle": "IBM article."
    },
    "password": {
      "title": "Change Password",
      "currentpassword": "Current Password",
      "newpassword": "New Password",
      "confirmpassword": "Confirm New Password",
      "changepassword": "Change Password"
    },
    "updateapplication": {
      "title": "Update User Information",
      "subtitle": "Please update your information with the required fields below to use the latest Izzi Wallet features.",
      "created": "Your updated data are being processed. Please wait a few minutes.",
      "waitlist": "You are on the waitlist. We will notify you when you can use more Web3 features in Izzi Wallet."
    }
  }
}
